import { HeaderNavigationItem } from "components/UI/DynamicHeaderNavigation/atoms/headerNavigationAtom.ts";
import { Route as AdvertiserPage } from "routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/";
import { Route as AdvertiserCommissionsPage } from "routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/";
import { Route as AffiliatePage } from "routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/";
import { Route as AffiliateCommissionGroupsPage } from "routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission";
import { Route as AffiliateOfferRequestsPage } from "routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer";
import { Route as AffiliatePayoutRequestsPage } from "routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout";
import { Route as FinanceBonusPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/bonus";
import { Route as FinanceCostsPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/cost";
import { Route as FinancePenaltyPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/penalty";
import { Route as FinanceRevenuePage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/revenue";
import { Route as DashboardOverviewPage } from "routes/_authenticated/$tenantSlug/_layout/index";
import { Route as ApiStepLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/api";
import { Route as ApiOldLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/api-old";
import { Route as ClickLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/click";
import { Route as ConversionLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/conversion";
import { Route as LeadLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/lead";
import { Route as PingtreeLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/pingtree";
import { Route as StructureLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/structure";
import { Route as TrackingFromLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback";
import { Route as TrackingFromStepsLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps";
import { Route as TrackingToOldLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to";
import { Route as TrackingToLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api";
import { Route as TrackingToStepsLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps";
import { Route as ValidationStepLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/validation";
import { Route as OfferOverviewPage } from "routes/_authenticated/$tenantSlug/_layout/offer";
import { Route as OfferDetailApiPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api";
import { Route as OfferDetailFormPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form";
import { Route as OfferDetailLinkPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link";
import { Route as OfferEditApiPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api";
import { Route as OfferEditFilterPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter";
import { Route as OfferEditFormPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form";
import { Route as OfferEditGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general";
import { Route as OfferEditLinkPage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link";
import { Route as OfferEditPingtreePage } from "routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree";
import { Route as AdvertiserReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/advertiser";
import { Route as AffiliateReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/affiliate";
import { Route as OffersReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/offer";
import { Route as PerformanceReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/performance";
import { Route as PingTreesReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/pingtree";
import { Route as TransactionsReportPage } from "routes/_authenticated/$tenantSlug/_layout/report/_layout/transaction";
import { Route as SettingFieldPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/field";
import { Route as SettingGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/general";
import { Route as SettingTagPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/tag";
import { Route as SettingTrackingPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/tracking";
import { Route as ToolDesignFormPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form";
import { Route as ToolDesignFormGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general";
import { Route as ToolDesignFunnelPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel";
import { Route as ToolDesignScreenPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen";
import { Route as ToolScenarioIntegrationPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration";
import { Route as ToolScenarioIntegrationEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor";
import { Route as ToolScenarioIntegrationEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old";
import { Route as ToolScenarioIntegrationGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general";
import { Route as ToolStructureFeedPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed";
import { Route as ToolStructureFeedEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old";
import { Route as ToolStructureFeedGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general";
import { Route as ToolStructureFeedStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure";
import { Route as ToolStructureLeadPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead";
import { Route as ToolStructureLeadEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old";
import { Route as ToolStructureLeadGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general";
import { Route as ToolStructureLeadStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure";
import { Route as ToolStructureUserPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user";
import { Route as ToolStructureUserEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old";
import { Route as ToolStructureUserGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general";
import { Route as ToolStructureUserStructurePage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure";
import { Route as ToolTrackingFromPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback";
import { Route as TrackingToolFromEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor";
import { Route as TrackingToolFromEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old";
import { Route as TrackingToolFromGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general";
import { Route as ToolTrackingToPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api";
import { Route as TrackingToolToEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor";
import { Route as TrackingToolToEditorOldPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old";
import { Route as TrackingToolToGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general";
import { Route as ValidationEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor";
import { Route as ValidationGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general";
import { PermissionEnum } from "types/enums";

import type { AnyRoute } from "@tanstack/react-router";

export function getDashboardHeaderItems(): HeaderNavigationItem[] {
    return [{ route: DashboardOverviewPage as AnyRoute, customLabel: "common.overview" }];
}

export function getReportHeaderItems(): HeaderNavigationItem[] {
    return [
        {
            route: PerformanceReportPage,
        },
        {
            route: AffiliateReportPage,
        },
        {
            route: AdvertiserReportPage,
        },
        {
            route: OffersReportPage,
        },
        {
            route: PingTreesReportPage,
        },
        {
            route: TransactionsReportPage,
        },
    ];
}

export function getAdvertiserHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: AdvertiserPage, customLabel: "pages.advertiser.manage.title" },
        { route: AdvertiserCommissionsPage },
    ];
}

export function getAffiliateHeaderItems(): HeaderNavigationItem[] {
    return [
        {
            route: AffiliatePage,
            customLabel: "pages.affiliate.manage.title",
            requiredPermissions: [PermissionEnum.AffiliateManage],
        },
        { route: AffiliateCommissionGroupsPage },
        { route: AffiliatePayoutRequestsPage },
        { route: AffiliateOfferRequestsPage },
    ];
}

export function getFinanceHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: FinanceCostsPage },
        { route: FinancePenaltyPage },
        { route: FinanceRevenuePage },
        { route: FinanceBonusPage },
    ];
}

export function getLogHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: ClickLogsPage },
        { route: LeadLogsPage },
        { route: ConversionLogPage },
        { route: PingtreeLogPage },
        { route: ApiStepLogsPage },
        { route: ApiOldLogsPage },
        { route: StructureLogsPage },
        { route: ValidationStepLogPage },
        { route: TrackingFromLogsPage },
        { route: TrackingFromStepsLogsPage },
        { route: TrackingToLogsPage },
        { route: TrackingToStepsLogsPage },
        { route: TrackingToOldLogsPage },
    ];
}

export function getOfferHeaderItems(): HeaderNavigationItem[] {
    return [{ route: OfferOverviewPage, customLabel: "common.overview" }];
}

export function getOfferDetailHeaderItems(): HeaderNavigationItem[] {
    return [{ route: OfferDetailLinkPage }, { route: OfferDetailFormPage }, { route: OfferDetailApiPage }];
}

export function getOfferEditHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: OfferEditGeneralPage },
        { route: OfferEditLinkPage },
        { route: OfferEditFormPage },
        { route: OfferEditApiPage },
        { route: OfferEditFilterPage },
        { route: OfferEditPingtreePage },
    ];
}

export function getSettingHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: SettingGeneralPage },
        //{ route: SettingUserPage },
        { route: SettingTrackingPage },
        { route: SettingTagPage },
        { route: SettingFieldPage },
        //{ route: SettingPlanPage },
    ];
}

export function getToolDesignHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ToolDesignFormPage }, { route: ToolDesignScreenPage }, { route: ToolDesignFunnelPage }];
}

export function getToolDesignFormHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ToolDesignFormGeneralPage }];
}

export function getToolTrackingHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ToolTrackingFromPage }, { route: ToolTrackingToPage }];
}

export function getToolStructureHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ToolStructureLeadPage }, { route: ToolStructureUserPage }, { route: ToolStructureFeedPage }];
}

export function getToolStructureLeadHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: ToolStructureLeadGeneralPage },
        { route: ToolStructureLeadStructurePage },
        { route: ToolStructureLeadEditorOldPage },
    ];
}

export function getToolScenarioIntegrationHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: ToolScenarioIntegrationGeneralPage },
        { route: ToolScenarioIntegrationEditorPage },
        { route: ToolScenarioIntegrationEditorOldPage },
    ];
}

export function getTrackingToolFromItems(): HeaderNavigationItem[] {
    return [
        { route: TrackingToolFromGeneralPage },
        { route: TrackingToolFromEditorPage },
        { route: TrackingToolFromEditorOldPage },
    ];
}

export function getTrackingToolToItems(): HeaderNavigationItem[] {
    return [
        { route: TrackingToolToGeneralPage },
        { route: TrackingToolToEditorPage },
        { route: TrackingToolToEditorOldPage },
    ];
}

export function getToolStructureUserHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: ToolStructureUserGeneralPage },
        { route: ToolStructureUserStructurePage },
        { route: ToolStructureUserEditorOldPage },
    ];
}

export function getToolStructureFeedHeaderItems(): HeaderNavigationItem[] {
    return [
        { route: ToolStructureFeedGeneralPage },
        { route: ToolStructureFeedStructurePage },
        { route: ToolStructureFeedEditorOldPage },
    ];
}

export function getToolScenarioPageItems(): HeaderNavigationItem[] {
    return [{ route: ToolScenarioIntegrationPage }];
}

export function getToolValidationFieldHeaderItems(): HeaderNavigationItem[] {
    return [{ route: ValidationGeneralPage }, { route: ValidationEditorPage }];
}

export const getToolScenarioFieldHeaderItems = getToolValidationFieldHeaderItems;
